import React from 'react'
import { Result, Button } from 'antd'

import { Link } from 'react-router-dom'

const success = () => (
  <Result
    status='success'
    title='Confirmed'
    subTitle='Successful registration.'
    extra={
      <Link to='/auth/login'>
        <Button type='primary'>Log In</Button>
      </Link>
    }
  />
)

export default success
